import { render } from "./ProductLift.vue?vue&type=template&id=082bb711&scoped=true"
import script from "./ProductLift.vue?vue&type=script&lang=js"
export * from "./ProductLift.vue?vue&type=script&lang=js"

import "./ProductLift.vue?vue&type=style&index=0&id=082bb711&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082bb711"]])

export default __exports__